// extracted by mini-css-extract-plugin
export var logo = "styles-module--logo--8448a";
export var section = "styles-module--section--b9d89";
export var splitLeft = "styles-module--splitLeft--291a2";
export var splitRight = "styles-module--splitRight--4d496";
export var tagline = "styles-module--tagline--57baf";
export var title = "styles-module--title--43ba0";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--8ff61";